<script lang="ts">
  import Divider from "../system/Divider.svelte";
</script>

<main class="mx-4 -mb-24">
  <div
    class="grid md:grid-cols-[minmax(16rem,2fr),minmax(0,8fr)] 2xl:grid-cols-[22rem,minmax(0,11fr)]"
  >
    <div class="pb-8">
      <div class="scroller sidebar h-56 md:h-[calc(100vh-98px)]">
        <slot name="sidebar-links" />
      </div>
    </div>
    <!-- Divider to split nav and text in single-column layout -->
    <div class="visible md:hidden w-90">
      <Divider />
    </div>
    <div class="flex w-full justify-center md:border-l border-c-gray-10">
      <div
        class="grid grid-cols-1 lg:grid-cols-[minmax(0,8fr),minmax(0,3fr)] md:pl-8 md:pr-4 lg:pr-0 lg:gap-4 w-full max-w-screen-xl"
      >
        <slot />
      </div>
    </div>
  </div>
</main>

<style lang="postcss">
  .sidebar {
    @apply sticky top-[65px] flex flex-col mr-1 mt-2 pt-2 pb-2 pr-1;
  }

  .scroller {
    overflow-y: auto;
    overflow-y: overlay;
    scrollbar-color: transparent transparent; /* Firefox only */
  }

  .scroller:hover {
    scrollbar-color: rgb(90, 90, 90) rgba(0, 0, 0, 0); /* Firefox only */
  }

  .scroller::-webkit-scrollbar {
    width: 8px;
  }

  .scroller::-webkit-scrollbar-thumb {
    background: transparent; /* Safari fix */
    border-radius: 10px;
  }

  .scroller:hover::-webkit-scrollbar-thumb {
    background: rgb(90, 90, 90); /* Safari fix */
  }
</style>
